// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DataCacheToolType } from '../DataCacheToolEnums';
import { FillableDataCacheTool } from './FillableDataCacheTool';
export class TriangleDataCacheTool extends FillableDataCacheTool {
    /**
     * Constructor for TriangleDataCacheTool
     */
    constructor() {
        super();
        this.ToolType = DataCacheToolType.Triangle;
        this.InitPoints(3);
    }
    /**
     * Gets the minimum points count required for the tool
     * @returns {number} - Minimum points count
     */
    MinPointsCount() {
        return 3;
    }
    /**
     * Gets the maximum points count required for the tool
     * @returns {number} - Maximum points count
     */
    MaxPointsCount() {
        return 3;
    }
}
